export const removeLeadingZero = (value: string) => {
  if (value === `0`) return value;
  if (value.substring(0, 2) === `0.`) return value;

  const newValue = value.replace(/^0+/, ``);
  return newValue;
};
